const parametrizationCurveDepedentsCDHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false
      }
    ]
  },
  {
    group: 'Loja',
    columns: [
      {
        name: 'Id',
        id: 'loja-id',
        show: true
      },
      {
        name: 'Descricao',
        id: 'loja-descricao',
        show: true
      }
    ]
  },
  {
    group: 'Centro Distribuicao',
    columns: [
      {
        name: 'Id',
        id: 'cd-id',
        show: true
      },
      {
        name: 'Descricao',
        id: 'cd-descricao',
        show: true
      }
    ]
  }
]

export default parametrizationCurveDepedentsCDHeader
